// extracted by mini-css-extract-plugin
module.exports = {"border":"terms_border__1zfFn","activeBorder":"terms_activeBorder__1-Dni","error":"terms_error__Z-ko2","bodyCenter":"terms_bodyCenter__LVOzW"};